/**
 * @generated SignedSource<<91e5b89f49ed721237cede62817be62c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type PackageBillingType = "ONE_TIME" | "SUBSCRIPTION";
import { FragmentRefs } from "relay-runtime";
export type packageMissingPaymentMethod_memberPackage$data = {
  readonly package: {
    readonly billingType: PackageBillingType;
  };
  readonly squareCard: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "packageMissingPaymentMethod_memberPackage";
};
export type packageMissingPaymentMethod_memberPackage$key = {
  readonly " $data"?: packageMissingPaymentMethod_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"packageMissingPaymentMethod_memberPackage">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "packageMissingPaymentMethod_memberPackage"
};

(node as any).hash = "71cc86e5d30b4f6a896a49d7089b512f";

export default node;
